import { render, staticRenderFns } from "./teampaymessage.vue?vue&type=template&id=5798e02e&scoped=true&"
import script from "./teampaymessage.vue?vue&type=script&lang=js&"
export * from "./teampaymessage.vue?vue&type=script&lang=js&"
import style0 from "./teampaymessage.vue?vue&type=style&index=0&id=5798e02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798e02e",
  null
  
)

export default component.exports